import { PlaceholderPage } from "./placeholder-page";

export function NonStockItemsPage() {
  return (
    <PlaceholderPage 
      title="Non-Stock Items" 
      description="This feature is planned for a future release."
    />
  );
}
